'use client';

import { type ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 py-4 sm:py-6 md:py-8">{children}</main>
    </div>
  );
}

